import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';
import Carrinho from '../../../assets/emojis/carrinho/carrinho@3x.png';

export default class BairroModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.idBairro,
            letra: props.letraBairro,
            nomeClass: 'div-input',
            nome: ''
        }
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'nome':
                this.setState({
                    nome: event.target.value
                });
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <div className="header">
                    <img alt="" className="emoji" src={Carrinho} />
                    <h1>Crie uma nova categoria</h1>
                </div>

                <div className="input-valor">
                    <div className={this.state.nomeClass}>
                            <input
                                value={this.state.nome}
                                onFocus={() => {
                                    this.setState({
                                        nomeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        nomeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.handleInputs(e)
                                }
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Nome do categoria</span>
                            </label>
                    </div>
                </div>

                <div className="botao">
                    <button 
                        onClick={() => this.props.criar(this.state.nome)}
                        className="salvar">Criar categoria</button>
                </div>
            </Container>
        )
    }
}